'use client';

import { useTranslations } from 'next-intl';
import { BaseLineClose } from '@/app/components/icons/BaseLineClose';
import { SITE } from '@/app/constants';
import { useGlobalModal } from '@/app/hooks';
import { useStore } from '@/app/providers/store';
import { cn, reportEvent } from '@/app/utils';
import { useRouter } from '@/i18n/routing';

const Q4_TITLE_IMAGE = `${SITE === 'china' ? 'https://image01-aliyun.vidu.zone' : 'https://image01.cf.vidu.studio'}/vidu/media-asset/q4title-preview2-b50181f9.webp`;

export const Q4LaunchBanner = ({ onClose, className }: { onClose: () => void; className?: string }) => {
  const t = useTranslations('q4LaunchCampaign');
  const router = useRouter();
  const { open: openLoginDialog } = useGlobalModal('loginDialog');
  const userInfo = useStore((state) => state.userInfo);
  const promotionKey = SITE === 'china' ? 'promotionChina' : 'promotionGlobal';

  const navigate = () => {
    reportEvent('element_click', { element_name: 'q4_launch_top_banner' });
    if (userInfo) {
      router.push('/subscription/personal');
      return;
    }
    openLoginDialog({ redirectUrl: '/subscription/personal' });
  };

  return (
    <div
      className={cn(
        'relative isolate flex min-h-[41px] w-full cursor-pointer items-center overflow-hidden bg-[#08a2dc] px-4 text-white',
        className,
      )}
      onClick={navigate}
    >
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_75%_520%_at_56%_50%,rgba(78,75,255,0.20)_0%,rgba(78,75,255,0)_72%),linear-gradient(90deg,#129EE1_0%,#2298DF_30%,#86B5EC_62%,#C4D5F1_80%,#DFC5C9_100%)]" />
      <div className="relative z-10 mx-auto flex min-w-0 items-center justify-center gap-6 overflow-hidden sm:gap-3">
        <img src={Q4_TITLE_IMAGE} alt="Vidu Q4" className="h-[26px] w-auto shrink-0 sm:h-5" />
        <span className="truncate font-medium text-base sm:text-xs">{t('banner.title')}</span>
        <span className="shrink-0 font-semibold text-xs sm:hidden">{t(promotionKey)}</span>
      </div>
      <button
        type="button"
        className="relative z-10 ml-3 shrink-0 text-white transition-colors hover:text-white/80"
        aria-label={t('banner.close')}
        onClick={(event) => {
          event.stopPropagation();
          reportEvent('element_click', { element_name: 'q4_launch_top_banner_close' });
          onClose();
        }}
      >
        <BaseLineClose className="size-4" />
      </button>
    </div>
  );
};
